import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { PBIModel } from '../ndm/models/pbi.model';
import { PBIService } from '../services/pbi.service';
import { SharedService } from '../services/shared.service';

@Injectable({
    providedIn: 'root',
})
export class PBIResolver  {
    pbiModel: PBIModel;
    constructor(
        private router: Router,
        private sharedService: SharedService,
        private activatedRoute: ActivatedRoute,
        private pbiService: PBIService
    ) {
    }
    async resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<any> {
        return  this.pbiService.getPBIToken().subscribe((res: any) => {
            this.pbiModel = JSON.parse(res.body); 
            return JSON.parse(res.body);
        });
    }
}